module.exports = __webpack_public_path__ + "img/mastercardLogo.e5eeeafd.png";